import { defineStore } from 'pinia'
import ApiService from '@/api/ApiService'

/* eslint-disable import/prefer-default-export */
const MODULES_LISTS = {
    country: { module: 'country', listName: 'countryOptions' },
    countryFinancingAvailable: {
        module: 'country',
        listName: 'countryFinancingAvailableOptions',
    },
    countrySignatoryResidency: {
        module: 'country',
        listName: 'countrySignatoryResidencyOptions',
    },
    oem: { module: 'invite', listName: 'oemOptions' },
    billingUnit: { module: 'billingUnit', listName: 'billingUnitOptions' },
    billingUnitDecimals: { module: 'billingUnitDecimals', listName: 'billingUnitDecimalsOptions' },
    contractDuration: { module: 'contractDuration', listName: 'contractDurationOptions' },
    roles: { module: 'invite', listName: 'rolesOptions' },
    internalRoles: { module: 'internalRoles', listName: 'internalRolesOptions' },
    customizationDegree: { module: 'unitType', listName: 'customizationDegreeOptions' },
    productType: { module: 'productType', listName: 'productTypeOptions' },
    partners: { module: 'partners', listName: 'partnersOptions' },
    billingEntities: { module: 'billingEntities', listName: 'billingEntityOptions' },
}

export const useOptionsStore = defineStore('options', {
    state: () => ({
        countryOptions: [],
        countryFinancingAvailableOptions: [],
        countrySignatoryResidencyOptions: [],
        billingUnitOptions: [],
        billingUnitDecimalsOptions: [],
        contractDurationOptions: [],
        ownedUsersOptions: [],
        rolesOptions: [],
        internalRolesOptions: [],
        oemOptions: [],
        customizationDegreeOptions: [],
        productTypeOptions: [],
        partnersOptions: [],
        billingEntityOptions: [],

        saving: false,
    }),

    getters: {
        getValueByLabel: (state) => (moduleName) => (label) => {
            const { listName } = MODULES_LISTS[moduleName]
            const item = state[listName].find((i) => i.label.toString() === label.toString())
            return item ? item.value : null
        },

        getLabelByValue: (state) => (moduleName) => (value) => {
            const { listName } = MODULES_LISTS[moduleName]
            const item = state[listName].find((i) => i.value === value)
            return item ? item.label : null
        },
    },

    actions: {
        addList({ moduleName, list }) {
            const config = MODULES_LISTS[moduleName]
            if (!config) return
            const { listName } = config
            const optionsList = Object.entries(list).map(([label, value]) => ({ label, value }))
            this[listName] = optionsList
        },

        addItemToList(moduleName, item) {
            const { listName } = MODULES_LISTS[moduleName]
            if (listName) {
                this[listName].push(item)
            }
        },

        updateItemInList(moduleName, item) {
            const { listName } = MODULES_LISTS[moduleName]
            if (listName) {
                const index = this[listName].findIndex((i) => i.value === item.value)
                if (index !== -1) {
                    this[listName][index] = item
                }
            }
        },

        findItemByLabelAndUpdateValue(moduleName, item) {
            const { listName } = MODULES_LISTS[moduleName]
            if (listName) {
                const index = this[listName].findIndex(
                    (i) => i.label.toString() === item.label.toString()
                )
                if (index !== -1) {
                    this[listName][index].value = item.value
                }
            }
        },

        removeItemFromList(moduleName, item) {
            const { listName } = MODULES_LISTS[moduleName]
            if (listName) {
                this[listName] = this[listName].filter((i) => i.value !== item.value)
            }
        },

        async saveItem({ type, route, name }) {
            if (this.saving) return

            this.saving = true
            try {
                const response = await ApiService.post(route, { name })

                const newItem = {
                    label: response.data.name,
                    value: response.data.id,
                }

                this.addItemToList(type, newItem)

                const successMessage = '§ui_message.create_successful'
                this.toast.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: successMessage,
                    life: this.getToastDuration(successMessage, 'success'),
                })

                return response.data
            } catch (error) {
                console.error('Error creating item:', error)

                const errorMessage = '§ui_message.create_failed'
                this.toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: errorMessage,
                    life: this.getToastDuration(errorMessage, 'error'),
                })

                throw error
            } finally {
                this.saving = false
            }
        },
    },
})
